<template>
  <div class="info">
    <div class="info-content">
      <div class="left">
        <div class="l-t">
          <div class="title">中国银行股份有限公司桌面云系统(IDV架构)选型项目采购公告</div>
          <p class="time">2021-12-30</p>
        </div>
        <div class="left-c">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中钢招标有限责任公司（采购代理机构）受中国银行股份有限公司委托，以公开邀请与竞争性磋商相结合的方式对中国银行股份有限公司桌面云系统（IDV架构）选型项目进行国内公开选型，现邀请符合条件的潜在供应商参与本项目选型。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>一、项目名称：</strong>桌面云系统（IDV架构）选型项目</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>二、采购编号：</strong>2140STC42968</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>三、项目简介：</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）选型内容</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国银行股份有限公司以公开的方式对桌面云系统（IDV架构）及其供应商进行入围选型，选型入围有效期为自签订入围协议之日起3年，入围供应商数量不多于3家，本项目的入围供应商将获得中国银行股份有限公司在入围有效期内的产品供货资格，选型入围价格为后续实际采购价格，实行定价模式。在选型入围有效期内，如入围供应商欲以新投入市场的产品取代入围产品，更新产品的技术配置指标及性能不得低于其入围的产品、价格不得高于最终入围价格，且须经过采购人的认可。本项目采购人不承诺在入围有效期内实际使用入围供应商的入围产品、不承诺授予入围供应商实际采购合同金额。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）选型产品</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本项目共1个包，具体选型产品如下：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;选型产品/货物名称：桌面云平台及配套组件、IDV桌面用户使用许可</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：1)供应商须对包内的全部产品进行响应且所报产品须为同一品牌，不允许拆包响应，否则其响应文件将被拒绝；2)选型产品详细要求见采购文件第五章，供应商须按此在响应文件中报出拟参加选型的产品型号。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）选型产品的采购范围：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采购范围：选型产品的供货及相关伴随服务 (含指导安装、技术培训等，不包括产品的安装和调试)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;交货地点：中国银行股份有限公司全国各级单位所在地，具体交货地点以产品供货合同为准</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>四、★供应商资格要求（须同时满足）：</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）供应商的资质要求如下：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. 供应商须是有能力履行本选型内容要求和提供入围采购产品及服务的原厂商。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. 供应商须为中华人民共和国境内（港澳台除外）合法注册的独立法人，遵守国家有关法律、法规，须在法律和财务上独立，具有健全的财务会计制度和公司治理措施，合法运作，商业信誉良好；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）供应商所提供产品的资质要求</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. 供应商所报产品系列，须提供2017年1月1日至今的选型入围或销售案例，要求所报案例须累积5000点以上，其中须有1个以上案例规模达到500点以上（需提供用户合同首页和产品清单页的复印件，原件备查）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：合同乙方是原厂或原厂代理，供应商同时提供证明合同中的产品品牌型号和本项目所报产品属于同系列的证明文件。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. 供应商须保证，采购人在其本国使用供应商提供的产品时，不存在任何已知的不合法的情形，也不存在任何已知的与第三方专利权、著作权、商标权或工业设计权相关的任何争议。如果有任何因采购人使用供应商提供的产品而提起的侵权指控，供应商（包括原厂商）须依法承担全部责任。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）其他要求：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. 供应商须在法律和财务上独立、合法运作并独立于采购人和采购代理机构，不得直接或间接地与采购人为本项目所委托的咨询公司或其附属机构有任何关联。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6. 供应商不存在环境污染、非法用工等引发环境和社会风险的违法违规行为。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7. 供应商须从采购代理机构获得采购文件并登记备案，否则不能参加本次项目的竞争。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. 存在关联关系的不同供应商，不得同时参加本项目。关联关系企业包含以下情况：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）与本企业单位负责人为同一人的其他企业；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）与本企业存在直接控股、管理关系的其他企业。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;供应商应向采购人如实披露与本单位存在关联关系的其他企业。采购人有权取消关联关系企业参与该项目的资格或重新组织谈判。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9. 供应商之间不得相互串通谈判报价，不得排挤其他供应商的公平竞争，损害采购人或者其他供应商的合法权益。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10. 供应商在响应文件中进行响应，如供应商对信息披露无异议，须填写《采购信息公开渠道社会披露承诺书》；如供应商对完全披露有异议，需附相关说明。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>五、获取采购文件：</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）时间：即日起至2022年1月14日止，每天9：00-17：00（北京时间，节假日除外）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）地点：中钢招标有限责任公司线上，为减少人员聚集，疫情期间我公司招标文件暂停现场发售，改为电汇支付标书款、电子邮件送达招标文件的方式发售。纸质招标文件和标书款发票的获取事宜详询采购代理机构项目联系人。非常时期如有不便，敬请谅解。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）售价：400元人民币/包</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四）方式：供应商购买招标文件须同时提供以下材料，发送至指定邮箱516499184@qq.com，邮件主题注明“采购编号_文件购买”：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.供应商企业法人营业执照或事业单位法人证书或登记证或其他有效证明文件复印件；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.供应商法定代表人授权书或单位介绍信（加盖公章）照片；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.《供应商联系信息表》（附件2）word文件及签字件照片，以便及时通知有关项目信息；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.《供应商开票信息表》（附件3）word文件及盖章件照片，若疫情期间盖章不便可后补；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.汇款凭证</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;附件2、3、4下载网址：https://tendering.sinosteel.com/zgzb/bzzx/moreinfo.html</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>六、响应文件的递交</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）递交响应文件截止时间为2022年1月21日10：00（北京时间）。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）响应文件递交地点：中钢国际广场一层东门（北京市海淀大街8号）。因疫情原因采购项目会议（涉及后续谈判时间安排等内容）通过腾讯会议的方式线上进行，腾讯会议的进入方式将在响应文件递交截止前以邮件形式发至各供应商邮箱。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）响应文件须密封后于递交响应文件截止时间之前递交至指定地点，逾期送达或不符合规定的响应文件恕不接受。响应文件一经递交不予退还。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（四）本项目不接受邮寄、传真形式递交的响应文件。供应商须派其委任的本项目授权代表在递交响应文件截止时间之前将响应文件送达采购代理机构并签字确认，供应商须承担因未送达或未签字所造成的一切责任。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采 购 人：中国银行股份有限公司</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地 址：北京市复兴门内大街1号</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采购代理机构：中钢招标有限责任公司</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地 址：北京市海淀大街8号中钢国际广场16层</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮 编：100080</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采购项目联系人：刘圣钰、马娟娟、聂娅琼、陈俊</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系方式（购买文件、发票咨询）：010-62688223、516499184@qq.com（邮箱）；</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系方式（项目问询）：010-62686390、62688251、liusy5@sstc20.com（邮箱）。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开户名称：中钢招标有限责任公司</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开户银行：中国民生银行股份有限公司北京大兴新城支行</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;账 号：9576032800000075</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;行 号：305100001750</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本项目采购公告将在《中国采购与招标网》(http://www.chinabidding.com.cn)和中国银行网站(http://www.boc.cn)进行发布。</p>
          <p class="text-r">中钢招标有限责任公司</p>
          <p class="text-r">2021年12月30日</p>
        </div>

      </div>
      <div class="right">
<!--        <div class="r-c">-->
<!--          <div class="fts-20 title">采购信息发布</div>-->
<!--          <p class="fts-18">企业和个人采购需求信息发布</p>-->
<!--          <p class="fts-18 mt-20">收费标准：600元/千条</p>-->
<!--          <p class="fts-18">收费方式：对公转账</p>-->
<!--          <p class="fts-18 mt-20">发布信息请致电01088589100</p>-->
<!--          <p class="fts-18">联系人：范老师</p>-->
<!--          <p class="fts-18 mt-20">请您通过网银转账，或自行到银行进行汇款，汇款账号如下：</p>-->
<!--          <p class="fts-18">户 名：北京正采信息技术研究院有限公司</p>-->
<!--          <p class="fts-18">账 号：0200207709200084916</p>-->
<!--          <p class="fts-18">开户行：中国工商银行股份有限公司北京西四环支行</p>-->
<!--          <p class="fts-18">行 号：102100020778 (非必填)</p>-->
<!--          <p></p>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";

export default {
  name: "info1",
  created() {
    let temp = localStorage.getItem("wzId2")
    if (temp != 2) {
      router.replace("/")
    }
  },
  unmounted() {
    localStorage.removeItem("wzId2")
  }
};
</script>

<style lang="scss" scoped>
.w-1 {
  width: 100px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.w-2 {
  width: 300px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.text-r {
  text-align: right;
}
.info {
  background-color: #f1f1f1;
  padding-bottom: 90px;
  min-width: 1200px;
  .info-content {
    width: 1200px;
    margin: auto;
    display: flex;
    padding-top: 40px;
    .left {
      width: 840px;
      .left-c {
        padding: 20px;
        p {
          font-size: 18px;
          line-height: 35px;
        }
      }
      //.title {
      //  font-size: 20px;
      //  font-weight: bold;
      //  border-bottom: 1px solid #bbbbbb;
      //  padding: 20px 20px;
      //}
      .l-t {
        border-bottom: 1px solid #bbbbbb;
        padding: 20px 20px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
      .time {
        font-size: 16px;
        text-align: center;
        margin-top: 8px;
      }
    }
    .right {
      width: 360px;
      padding: 20px 0 0 15px;
      position: relative;
      .r-c {
        width: 320px;
        background-color: #089CB0;
        //height: 430px;
        padding: 30px 10px;
        border-radius: 8px;
        box-sizing: border-box;
        color: #ffffff;

        position: fixed;
        p {
          margin: 2px 0;
        }
        .title {
          //font-weight: 800;
        }
        .mt-20 {
          margin-top: 15px;
        }
        .fts-20 {
          font-size: 20px;
        }
        .fts-18 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
